import { ROUTES } from '@router'

export const getLocationClose = (currentRoute, $navigation) => {
  const { from, ...query } = currentRoute.query
  const { route: fallback } = $navigation.resolve({
    type: 'internal',
    name: ROUTES.LANDING.SEARCH,
  })

  return {
    path: from || fallback.path,
    query,
    params: currentRoute.params,
    hash: currentRoute.hash,
  }
}

export const createCanonicalPageQueryString = (query) => {
  return query.page && query.page > 1 ? `?page=${query.page}` : ''
}
